/*
Author: Srinivas P
Date: 05/12/2019
Issue Description: Left menu stepper is showing wrong when navigated from Profile icon-->Add New Legal Entity PL-1986
SearchString: issue stepper
*/
/*
Author: Shivakumar
Date: 24/03/2020
Issue Description: Code refactored and not removing some commenting lines for future reference.
*/
<template>
  <div>
    <toolbar brandName="Paylief Onboarding" :backLinkUrl="backLinkUrl"></toolbar>
    <div class="mainContainer">
      <div>
        <nav-drawer
          :title="entity_name"
          :backLinkText="backLinkText"
          :backLinkUrl="backLinkUrl"
          :items="nav_items"
          :logoUrl="logoUrl"
        ></nav-drawer>
      </div>
      <div class="navComponent">
        <keep-alive>
          <component :is="currentComponent" @updateIndex="updateNavItems"></component>
        </keep-alive>
      </div>
      <!-- <scroll-icon></scroll-icon> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Toolbar from "./shell/OnboardingToolbar.vue";
import NavDrawer from "./shell/OnboardingNavDrawer.vue";
import OrgSummaryNavDrawer from "./shell/OrgSummaryNavDrawer.vue";
import company_info from "./pages/orgInfo.vue";
import legal_entities from "./pages/legal-entities/LegalEntitiesIntro.vue";
// import business_units from "./pages/business-units/BusinessUnitsIntro.vue";
// import business_unit_types from "./pages/business-units/BusinessUnitTypesIntro.vue";
import locations from "./pages/le-level/locations/LocationsIntro.vue";
import cost_center from "./pages/le-level/cost-center/CostCenterIntro.vue";
import legacyData from "./pages/le-level/legacy/LegacyIntro.vue";
import grades from "./pages/le-level/grades/SalaryGradesIntro.vue";
import designation from "./pages/le-level/designation/DesignationIntro.vue";
import level from "./pages/le-level/level/LevelIntro.vue";
import ctcSlab from "./pages/le-level/ctcslabs/CTC_Intro.vue"
import departments from "./pages/le-level/departments/DepartmentsIntro.vue";
import bands from "./pages/le-level/bands/BandsIntro.vue";
import employees from "./pages/le-level/employees/EmployeeDashboard.vue";
import paygroup from "./pages/le-level/paygroup/Paygroup.vue";
import statutory from "./pages/le-level/statutory/StatutoryIntro.vue";
import preferences from "./pages/le-level/preferences/PreferencesIntro.vue";
import empCategories from "./pages/le-level/empCategories/empCategoryIntro.vue";
import gratuity from "./pages/le-level/statutory/Gratuity.vue";
import fbpEligibility from "./pages/le-level/fbp/fbpEligibilityConfig.vue";
import fbpConfigure from "./pages/le-level/fbp/FbpConfigure.vue"; 
import fbpComponentGrouping from "../../dashboard/views/pages/HumanResources/fbpComponentGrouping.vue";
import hsbcPaymentSetting from "../../dashboard/views/pages/directPay/hsbcAccount/accountPageHsbc.vue"
import fbpMapping from "./pages/le-level/fbp/fbpMapping.vue";


/* ******************************************
  @Configs
* ******************************************/
const mapNameToComponents = {
  info: company_info,
  legal_entities: legal_entities,
  // business_units: business_units,
  // business_unit_types: business_unit_types,
  summary: () => import("./pages/summary.vue"),
  locations: locations,
  costcenters: cost_center,
  grades: grades,
  designation: designation,
  level:level,
  ctcSlab : ctcSlab,
  departments: departments,
  empCategories: empCategories,
  bands: bands,
  employees: employees,
  paygroup: paygroup,
  statutory: statutory,
  preferences: preferences,
  gratuity: gratuity,
  legacyData: legacyData,
  fbpEligibility: fbpEligibility,
  fbpComponentGrouping: fbpComponentGrouping,
  hsbcPaymentSetting: hsbcPaymentSetting,

  addLegalEntity: () => import("./pages/legal-entities/legal_entities.vue"),
  modifyLegalEntity: () => import("./pages/legal-entities/legal_entities.vue"),
  addEmpCategory: () =>
    import("./pages/le-level/empCategories/AddNewEmpCategory"),
  modifyEmpCategory: () =>
    import("./pages/le-level/empCategories/AddNewEmpCategory"),
  addBands: () => import("./pages/le-level/bands/add_New_Band.vue"),
  addPaygroup: () => import("./pages/le-level/paygroup/AddNewPaygroup.vue"),
  modifyPaygroup: () => import("./pages/le-level/paygroup/AddNewPaygroup.vue"),
  modifybands: () => import("./pages/le-level/bands/add_New_Band.vue"),
  addcostcenter: () =>
    import("./pages/le-level/cost-center/Add_CostCenter_Unit.vue"),
  modifycostcenter: () =>
    import("./pages/le-level/cost-center/Add_CostCenter_Unit.vue"),
  addGrades: () => import("./pages/le-level/grades/AddGrades.vue"),
  modifyGrades: () => import("./pages/le-level/grades/AddGrades.vue"),
  addSalaryRegister: () => import("./pages/le-level/legacy/AddLegacyData.vue"),
  modifySalaryRegister: () => import("./pages/le-level/legacy/AddLegacyData.vue"),
  addDesignations: () =>
    import("./pages/le-level/designation/AddDesignations.vue"),
  addLevels: () => import("./pages/le-level/level/AddLevels.vue"),
  addEmployee: () => import("./pages/le-level/employees/EditEmployee.vue"),
  editEmployee: () => import("./pages/le-level/employees/EditEmployee.vue"),
  employeeDashboard: () =>
    import("./pages/le-level/employees/EmployeeDashboard.vue"),
  modifyDesignations: () =>
    import("./pages/le-level/designation/AddDesignations.vue"),
  modifyLevels: () => import("./pages/le-level/level/AddLevels.vue"),
  addLocation: () => import("./pages/le-level/locations/AddLocation.vue"),
  modifyLocations: () => import("./pages/le-level/locations/AddLocation.vue"),
  fbpEligibilityConfig: () => import("./pages/le-level/fbp/fbpEligibilityConfig.vue"),
  // addBusiness: () => import("./pages/business-units/add_business_unit.vue"),
  // modifyBusiness: () => import("./pages/business-units/add_business_unit.vue"),
  // addBusinessUnitType: () =>
    // import("./pages/business-units/add_business_unit_types.vue"),/
  // modifyBusinessUnitType: () =>
    // import("./pages/business-units/add_business_unit_types.vue"),
  addComponent: () =>
    import("./pages/le-level/preferences/PreferencesAddNewComponent.vue"),
  modifyComponent: () =>
    import("./pages/le-level/preferences/PreferencesAddNewComponent.vue"),
  viewComponent: () =>
    import("./pages/le-level/preferences/ViewNewComponent.vue"),  
  addStructure: () =>
    import("./pages/le-level/preferences/CreateNewSalaryStructure.vue"),
  modifystructure: () =>
    import("./pages/le-level/preferences/CreateNewSalaryStructure.vue"),
  modifyStructureDetails: () =>
    import("./pages/le-level/preferences/SalaryStructureDetails.vue"),
  "customize-fields": () =>
    import("./pages/le-level/preferences/PayslipFields.vue"),
  list: () => import("./pages/le-level/departments/DepartmentsList.vue"),
  add: () => import("./pages/le-level/departments/AddDepartment.vue"),
  modifydepartment: () =>
    import("./pages/le-level/departments/AddDepartment.vue"),
  "payslip-preferences": () =>
    import("./pages/le-level/preferences/PayslipPreferences.vue"),
  addSlabPreferences: () => import("./pages/le-level/preferences/addSlabs.vue"),
  addFbpBand: () => import("./pages/le-level/misc/addFbpBand.vue"),
  misc: () => import("./pages/le-level/misc/miscIntro.vue"),
  modifyFbpBand: () => import("./pages/le-level/misc/addFbpBand.vue"),
  fbpConfigure: fbpConfigure,
  
  // addCtcSlab: ()=> import("./pages/le-level/ctcslabs/AddCTCs.vue"),
  modifyCtcSlab: ()=> import("./pages/le-level/ctcslabs/AddCtc.vue"),
  addCtcSlab:()=> import("./pages/le-level/ctcslabs/AddCtc.vue"),
  fbpMapping:()=> import("./pages/le-level/fbp/fbpMapping.vue"),
  addPerquisiteComponent: () => import("./pages/le-level/preferences/perquisitesAddNewComponent.vue"),
  modifyPerquisiteComponent: () => import("./pages/le-level/preferences/perquisitesAddNewComponent.vue"),
};

const getPathForStep = (entity_index, step_name, sub_step) => {
  if (sub_step == "modifyLegalEntity")
    return `/onboarding/${step_name}/${entity_index}/${sub_step}`;
  if (sub_step)
    return `/onboarding/entity/${entity_index}/${step_name}/${sub_step}`;
  else return `/onboarding/entity/${entity_index}/${step_name}`;
};

const nav_items_entity = entity_index => [
  {
    type: "section",
    header: "Company Info",
    items: [
      {
        type: "navitem",
        label: "Legal Entities Info",
        status: "pending",
        path: getPathForStep(
          entity_index,
          "legal_entities",
          "modifyLegalEntity"
        )
      },
      {
        type: "navitem",
        label: "Locations",
        status: "pending",
        path: getPathForStep(entity_index, "locations"),
        children: [
          {
            path: getPathForStep(entity_index, "locations", "addlocation")
          }
        ]
      }
    ]
  },

  {
    type: "section",
    header: "Payroll",
    items: [
      {
        type: "navitem",
        label: "Statutory Settings",
        status: "pending",
        path: getPathForStep(entity_index, "statutory")
      },
      {
        type: "navitem",
        label: "Departments",
        status: "pending",
        path: getPathForStep(entity_index, "departments")
      },
      {
        type: "navitem",
        label: "Cost Centres",
        status: "pending",
        path: getPathForStep(entity_index, "costcenters")
      },
      {
        type: "navitem",
        label: "Designations",
        status: "pending",
        path: getPathForStep(entity_index, "designation")
      },
      {
        type: "navitem",
        label: "Levels",
        status: "pending",
        path: getPathForStep(entity_index, "level")
      },

      {
        type: "navitem",
        label: "Salary Grades",
        status: "pending",
        path: getPathForStep(entity_index, "grades"),
        children: [
          {
            path: getPathForStep(entity_index, "grades", "addgrades")
          },
          {
            path: getPathForStep(entity_index, "grades", "adddesignations")
          }
        ]
      },
      {
        type: "navitem",
        label: "Employee Categories",
        status: "pending",
        path: getPathForStep(entity_index, "empCategories")
      },
      {
        type: "navitem",
        label: "Salary Bands",
        status: "pending",
        path: getPathForStep(entity_index, "bands")
      },
      {
        type: "navitem",
        label: "Miscellaneous",
        status: "pending",
        path: getPathForStep(entity_index, "misc"),
        children: [
          {
            path: getPathForStep(entity_index, "misc", "addFbpBand")
          }
        ]
      },
      {
        type: "navitem",
        label: "Payroll Preferences",
        status: "pending",
        path: getPathForStep(entity_index, "preferences"),
        children: [
          {
            path: getPathForStep(
              entity_index,
              "preferences",
              "modifyStructureDetails"
            )
          }
        ]
      },
      {
        type: "navitem",
        label: "Paygroups",
        status: "pending",
        path: getPathForStep(entity_index, "paygroup")
      },
      {
        type: "navitem",
        label: "Payment Settings",
        status: "pending",
        path: getPathForStep(entity_index, "hsbcPaymentSetting")
      },
    ]
  },
  {
    type: "section",
    header: "Flexible Benefit Plans",
    items:[
        {
        type: "navitem",
        label: "FBP Settings",
        status: "pending",
        path: getPathForStep(entity_index, "fbpConfigure"),
      },
           {
        type: "navitem",
        label: "FBP CTC Slab",
        status: "pending",
        path: getPathForStep(entity_index, "ctcSlab")
      },
      {
        type: "navitem",
        label: "FBP Component Grouping",
        status: "pending",
        path: getPathForStep(entity_index, "fbpComponentGrouping")
      },
      {
        type: "navitem",
        label: "FBP Eligibility",
        status: "pending",
        path: getPathForStep(entity_index, "fbpEligibility")
      },
    ]
  },
  {
    type: "section",
    header: "Others",
    items: [
      {
        type: "navitem",
        label: "Add Employee",
        status: "pending",
        path: getPathForStep(entity_index, "employeeDashboard")
        // children: [{
        //   path: getPathForStep(entity_index, 'employees', 'edit')
        // }]
      },
      {
        type: "navitem",
        label: "Legacy Data",
        status: "pending",
        path: getPathForStep(entity_index, "legacyData")
        // children: [{
        //   path: getPathForStep(entity_index, 'employees', 'edit')
        // }]
      }
    ]
  }
];

/* ******************************************
  @Main Component
* ******************************************/
export default {
  components: {
    Toolbar,
    NavDrawer,
    OrgSummaryNavDrawer
  },
  props: ["step_name", "level", "entity_index", "sub_step", "id"],
  data() {
    return {
      nav_items: [],
      backLinkText: "All Legal Entities",
      backLinkUrl: null,
      entity_name: "",
      logoUrl: ""
    };
  },
  created() {
    this.fetchAll();
    this.changeNavDrawer();
    // this.navItems =  nav_items_dashboard();
  },
  watch: {
    level: function() {
      this.changeNavDrawer();
    },
  
  },
  methods: {
    async fetchAll() {
      if (this.$_.isEmpty(this.entities)) {
        this.changeNavDrawer();
      }
    },

    updateNavItems(index) {
      this.nav_items = nav_items_entity(this.entity_index);
    },

    /*
      Author: Vaishnavi
      Date: 22/1//2019
      Issue Description: Commented lines related to navItems for each org related module as per design requirement
    */
    changeNavDrawer() {
      if (this.is_org_level) {
        this.backLinkUrl = this.orgId ? "/orgsummary" : "/welcome";
        this.backLinkText = "Organisation Summary";
        this.entity_name =
          this.orgData.length && this.orgId ? this.orgData[0].name : "";
        this.logoUrl = this.orgData[0] ? this.orgData[0].logoURL : null;

        // this.nav_items=[{
        //   type: "section",
        //   header: "Organisation",
        //   items: [{
        //       type: "navitem",
        //       label: "Organisation Info",
        //       status: "pending",
        //       path: "/onboarding/info"
        //     }]
        // }]
      } else if (this.is_le_level) {
        this.backLinkUrl = this.orgId ? "/orgsummary" : "/welcome";
        this.backLinkText = "Organisation Summary";
        this.entity_name = this.orgData.length ? this.orgData[0].name : "";
        this.logoUrl = this.orgData[0] ? this.orgData[0].logoURL : null;
        // start of issue Stepper
        if (this.entity_index > -1) {
          if (this.stepperState.length) {
            this.nav_items = this.stepperState;
          } else {
            this.nav_items = nav_items_entity(this.entity_index);
          }
        }
        // end of issue stepper
        // else
        //   this.nav_items=[{
        //     type: "section",
        //     header: "Legal Entity",
        //     items: [{
        //         type: "navitem",
        //         label: "Legal Entities Info",
        //         status: "pending",
        //         path: "/onboarding/legal_entities"
        //       }]
        //   }]
      // } else if (this.is_bu_level) {
      //   this.backLinkUrl = "/orgsummary";
      //   this.backLinkText = "Organisation Summary";
      //   this.entity_name = this.orgData.length ? this.orgData[0].name : "";
      //   this.logoUrl = this.orgData[0] ? this.orgData[0].logoURL : null;
        // this.nav_items=[{
        //   type: "section",
        //   header: "Business Units",
        //   items: [{
        //       type: "navitem",
        //       label: "List of all business units",
        //       status: "pending",
        //       path: "/onboarding/business_units"
        //     }]
        // }]
      // } else if (this.is_butype_level) {
      //   this.backLinkUrl = "/orgsummary";
      //   this.backLinkText = "Organisation Summary";
      //   this.entity_name = this.orgData.length ? this.orgData[0].name : "";
      //   this.logoUrl = this.orgData[0] ? this.orgData[0].logoURL : null;
        // this.nav_items=[{
        //   type: "section",
        //   header: "Business Unit Types Info",
        //   items: [{
        //       type: "navitem",
        //       label: "List of all business unit types",
        //       status: "pending",
        //       path: "/onboarding/business_unit_types"
        //     }]
        // }]
      } else {
        if (this.stepperState.length) {
          this.nav_items = this.stepperState;
        } else {
          this.nav_items = nav_items_entity(this.entity_index);
        }
        this.entity_name = this.entities[this.entity_index]
          ? this.entities[this.entity_index].legalName
          : null;
        this.entity_name = this.orgData.length ? this.orgData[0].name : "";
        this.backLinkUrl = "/orgsummary";
        this.backLinkText = "Organisation Summary";
        this.logoUrl = this.orgData[0] ? this.orgData[0].logoURL : null;
      }
    }
  },
  computed: {
    ...mapState({
      orgData: state => state.onboard.organization.data,
      orgId: state => state.onboard.organization.id,
      entities: state => state.onboard.legal_entities.data,
      stepperState: state => state.onboard.legal_entities.stepperStatus,
    }),
    is_org_level: {
      get() {
        return this.step_name == "info";
      }
    },
    is_le_level: {
      get() {
        return this.step_name == "legal_entities";
      }
    },
    // is_bu_level: {
    //   get() {
    //     return this.step_name == "business_units";
    //   }
    // },
    // is_butype_level: {
    //   get() {
    //     return this.step_name == "business_unit_types";
    //   }
    // },
    is_entity_level: {
      get() {
        return this.level == "entity";
      }
    },
    currentComponent: function() {
      if (this.sub_step) return mapNameToComponents[this.sub_step];
      else return mapNameToComponents[this.step_name];
    }
  }
};
</script>
<style lang="scss" scoped>
.navComponent {
  flex: 1 1 auto;
  width: 100%;
  margin-left: 250px;
  margin-top: 65px;
}

.mainContainer {
  display: flex;
  flex-direction: row;
}
</style>
